// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2q0Hl","inner":"styles_inner__k4tUQ","right":"styles_right__1-mV7","close":"styles_close__2WWKm","footer":"styles_footer__3lGJt"};